/* ============================================================
   INDEX.JS — Page-specific scripts for index.html
   ============================================================ */

// ===== CURTAIN REVEAL =====
document.body.style.overflow='hidden';
const curtainTl = gsap.timeline({onComplete:()=>{document.getElementById('curtain').remove();document.body.style.overflow=''}});

if(!motionReduced){
  // Hold for 1 second with logo visible
  curtainTl.to('#curtain-logo',{opacity:1,duration:0.3},0)
  // Line draws down the center
  .to('#curtain-line',{height:'100%',duration:0.5,ease:'power2.inOut'},1.0)
  // Logo fades out
  .to('#curtain-logo',{opacity:0,scale:0.8,duration:0.3,ease:'power2.in'},1.3)
  // Both halves slide apart
  .to('.curtain-left',{xPercent:-100,duration:0.8,ease:'power3.inOut'},1.5)
  .to('.curtain-right',{xPercent:100,duration:0.8,ease:'power3.inOut'},1.5)
  // Line fades
  .to('#curtain-line',{opacity:0,duration:0.3},1.5);
} else {
  // Skip animation, just remove immediately
  document.getElementById('curtain').remove();
}

// ===== HERO SCROLL-DRIVEN REVEAL =====
const heroTl = gsap.timeline({
  scrollTrigger:{
    trigger:'#hero',
    start:'top top',
    end:'+=200%',
    scrub:0.6,
    pin:true,
    pinSpacing:true,
    anticipatePin:1
  }
});

// Phase 1 (0-10%): Slow Ken Burns zoom on the splash art + fade out scroll cue
heroTl.to('.hero-bg',{scale:1.38,ease:'none',duration:1},0)
      .to('#hero-scroll-cue',{opacity:0,duration:0.08},0)

// Phase 2 (10-30%): Gradient overlay sweeps in
      .to('#hero-overlay',{opacity:1,duration:0.2},0.1)

// Phase 3 (30-60%): Content reveals staggered
      .to('.hero-reveal',{opacity:1,y:0,duration:0.08,stagger:0.04,ease:'power2.out'},0.3)

// Reduce motion: skip animations, show everything immediately

// ===== WORLD CARDS =====
// Cards entrance
gsap.from('.world-card-flip',{y:40,opacity:0,stagger:0.12,duration:0.6,ease:'expo.out',scrollTrigger:{trigger:'#worlds',start:'top 75%'}});

// Tap-to-flip on touch devices
if('ontouchstart' in window){
  document.querySelectorAll('.world-card-flip').forEach(card=>{
    card.addEventListener('click',()=>card.classList.toggle('flipped'));
  });
}

// ===== VALUE STACK ENTRANCE =====
gsap.from('.vs-row',{x:-20,opacity:0,stagger:0.08,duration:0.4,ease:'power2.out',scrollTrigger:{trigger:'.value-stack',start:'top 80%'}});
gsap.from('.vs-total',{opacity:0,duration:0.5,delay:0.6,ease:'power2.out',scrollTrigger:{trigger:'.value-stack',start:'top 80%'}});

// ===== STATS COUNT-UP =====
document.querySelectorAll('.stat-num').forEach(el=>{
  const target=parseInt(el.dataset.target);
  ScrollTrigger.create({
    trigger:'#stats-bar',start:'top 80%',once:true,
    onEnter:()=>{
      gsap.to({v:0},{v:target,duration:1.2,ease:'power2.out',
        onUpdate:function(){el.textContent=Math.round(this.targets()[0].v)}
      });
    }
  });
});

// ===== QUOTE CAROUSEL =====
(function(){
  const cards=document.querySelectorAll('.quote-card');
  const dots=document.querySelectorAll('.quote-dot');
  let idx=0,timer;
  function show(i){
    cards.forEach(c=>c.classList.remove('active'));
    dots.forEach(d=>d.classList.remove('active'));
    cards[i].classList.add('active');dots[i].classList.add('active');idx=i;
  }
  function next(){show((idx+1)%cards.length)}
  function start(){timer=setInterval(next,5000)}
  function stop(){clearInterval(timer)}
  dots.forEach(d=>d.addEventListener('click',()=>{stop();show(+d.dataset.idx);start()}));
  const container=document.getElementById('quotes-container');
  container.addEventListener('mouseenter',stop);
  container.addEventListener('mouseleave',start);
  start();
})();

// ===== SECTION ENTRANCES =====
['#shop','#creator','#proof','#final-cta'].forEach(s=>{
  gsap.from(s+' .section-head, '+s+' h2',{y:20,opacity:0,duration:0.6,ease:'expo.out',scrollTrigger:{trigger:s,start:'top 80%'}});
});

// ===== BEAT-MODE HUD =====
const bars=document.querySelectorAll('.beat-bar');
let lastScrollY=window.scrollY;
ScrollTrigger.create({
  onUpdate:self=>{
    if(motionReduced) return;
    const vel=Math.abs(self.getVelocity());
    const intensity=gsap.utils.clamp(0.3,1.0,vel/2500);
    const heights=[60,40,80];
    bars.forEach((b,i)=>{
      b.style.height=(20+heights[i]*intensity)+'px';
      b.style.opacity=0.25+intensity*0.6;
    });
  }
});
